import { render, staticRenderFns } from "./SmsPayN.vue?vue&type=template&id=63105b2a"
import script from "./SmsPayN.vue?vue&type=script&lang=js"
export * from "./SmsPayN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports